import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-dark-900 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/" className="text-gray-400 hover:text-white inline-flex items-center">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
        </div>

        <div className="card p-8 space-y-6">
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <section className="space-y-4">
            <h2 className="text-xl font-semibold">1. Service Terms</h2>
            <p>
              By using Network Relationship Manager (NRM), you agree to these terms of service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">2. Data Privacy</h2>
            <p>We maintain strict data privacy standards:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Your data belongs to you</li>
              <li>We do not share or sell your data</li>
              <li>We do not allow third-party access to your information</li>
              <li>We implement robust security measures</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">3. User Responsibilities</h2>
            <p>Users must:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Maintain account security</li>
              <li>Provide accurate information</li>
              <li>Comply with applicable laws</li>
              <li>Respect others' privacy</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">4. Prohibited Activities</h2>
            <p>Users may not:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Attempt to access other users' data</li>
              <li>Share account credentials</li>
              <li>Use the service for illegal purposes</li>
              <li>Attempt to breach security measures</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold">5. Contact</h2>
            <p>
              For questions about these terms, contact us at{' '}
              <a href="mailto:legal@nrm.example.com" className="text-primary-500 hover:underline">
                contact@neosavvy.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}